module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"allocation_id":"Allocation ID","hospital":"Hospital","hospital_placeholder":"Select a Hospital..."},"fr":{"allocation_id":"Allocation ID","hospital":"Hospital","hospital_placeholder":"Select a Hospital..."}}')
  delete Component.options._Ctor
}
